export default __webpack_public_path__ + "static/media/8.113d49d7.jpeg";